import $ from 'jquery'

const SELECTORS = {
    deleteAddressBtn: '[data-delete-address-btn]',
    countrySelect: '[data-address-country-select]'
}

class CustomerAddresses {
    constructor() {
        this.$deleteAddressBtn = $(SELECTORS.deleteAddressBtn)

        if (!this.$deleteAddressBtn.length && !$(SELECTORS.countrySelect).length) {
            return
        }

        this.bindEvents()
        this.initCountryProvinceSelectors()
    }

    bindEvents() {
        this.$deleteAddressBtn.on('click', function () {
            const formId = $(this).data('form-id')
            const confirmMessage = $(this).data('confirm-message')

            if (window.confirm(confirmMessage)) {
                Shopify.postLink(`/account/addresses/${formId}`, {
                    parameters: { _method: 'delete' }
                })
            }
        })
    }

    initCountryProvinceSelectors() {
        // Shopify.CountryProvinceSelector reads the selected country's data-provinces
        // attribute from country_option_tags and only shows the province field when
        // Shopify provides subregions for that country. Countries can be real-world
        // federations, such as Germany or Austria, and still have data-provinces="[]"
        // here, in which case the province container intentionally remains hidden.
        if (!window.Shopify || !Shopify.CountryProvinceSelector) {
            return
        }

        $(SELECTORS.countrySelect).each(function () {
            const formId = $(this).data('form-id')
            const countryId = formId ? `AddressCountry_${formId}` : 'AddressCountryNew'
            const provinceId = formId ? `AddressProvince_${formId}` : 'AddressProvinceNew'
            const provinceContainerId = formId
                ? `AddressProvinceContainer_${formId}`
                : 'AddressProvinceContainerNew'

            new Shopify.CountryProvinceSelector(countryId, provinceId, {
                hideElement: provinceContainerId
            })
        })
    }
}

$(document).ready(() => new CustomerAddresses())
